import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

export const Container = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "aligned",
})<{ aligned: "left" | "right" | "center" }>(
  {
    width: "100%",
    overflow: "hidden",
    "& p, span": {
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  ({ aligned }) => ({
    ...{
      textAlign: aligned,
    },
  })
);

export const FirstElementContainer = styled(Grid)({
  width: "100%",
});

export const SecondElementContainer = styled(Grid)(({ theme }) => ({
  "&  p, span": {
    color: theme.palette.text.disabled,
    fontSize: theme.typography.body2.fontSize,
  },
}));
